import React from 'react';
import {compose, hoistStatics, defaultProps, lifecycle} from 'recompose';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import Items from './Items';
import columnTypes from '../../../components/cms/grid/columnTypes';
import ModelService from '../../../services/tokens-balance.service';
import gc from '../../../components/cms/gridComponents';
import fh from "../../../helpers/form.helper";

const getColumns = t => [
  // {
  //   name: 'id',
  //   title: t('Id'),
  //   value: ({ item }) => (<span>{item.id}</span>),
  // },
  {
    name: 'amount',
    title: t('Amount'),
    filter: false,
  },
  {
    name: 'description',
    title: t('Description'),
    value: ({ item }) => (<span>{item.description}</span>),
  },
  {
    name: 'type',
    title: t('Type'),
    value: ({ item: { type } }) => (
      <Badge color={ModelService.getColorByType(type)}>
        {ModelService.getTypeTitle(type, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getTypeOptions(t)),
  },
  // {
  //   type: columnTypes.BUTTONS,
  // },
];

const enhance = compose(
  translate('core'),
  lifecycle({
    async componentDidMount() {
      if (this.props.match && this.props.match.params.company_id) {
        ModelService.baseUrl = ModelService.defaultBaseUrl.replace(':company_id', this.props.match.params.company_id);
        ModelService.baseRoute = ModelService.defaultBaseRoute.replace(':company_id', this.props.match.params.company_id);
      }
    },
  }),
  defaultProps({
    getColumns,
    service: ModelService,
  }),
);

export default hoistStatics(enhance)(Items);



// WEBPACK FOOTER //
// ./src/views/companies/tokensBalance/index.js